<template>
    <div class="div">
        <button v-if="isFilled" class="button is-small text-button bold"  @click="downloadPdf">
            {{ car.proforma_invoice.issued_date }}
        </button>
        <button v-else="" class="button is-small text-button">
            ---
        </button>
    </div>
</template>

<script>
    export default {
        props:['car'],
        computed: {
            isFilled() {
                if (this.car.proforma_invoice !== null){
                    return  true;
                }
            }
        },
        methods: {
            downloadPdf() {
                this.$store.dispatch('changeProformaInvoiceFieldValue', {
                    field: 'id',
                    value: this.car.proforma_invoice.id
                })
                this.$store.dispatch('downloadProformaInvoicePdf')
            },
        }
    }
</script>

<style scoped>
    .text-button {
        min-width: 55px;
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/InvoiceDownloadColumn.vue